import { atom } from "recoil";

export const DataDiTichState = atom({
  key: "DataDiTichState",
  default: null,
});
